import React, { Fragment } from 'react'
import { metaUIdevelopment } from '../../../../Utilites'
import MetaTagComponent from '../../../common/Meta/MetaTagComponent'
import ServiceDetailSection from '../../../services/ServiceDetailSection'
import { Code, Eye, Globe, Layers, LayoutTemplate, MonitorSmartphone, Move, Palette, PenTool, Route, Smile, Timer, TrendingUp, Users } from 'lucide-react'

const UIDevelopment = () => {
  const service = {
    slug: 'ui-ux-development',
    title: 'UI/UX Development',
    description: 'User-centered design solutions that create intuitive and engaging digital experiences.',
    shortDescription: 'User-centered design solutions for engaging digital experiences.',
    icon: Palette,
    gradient: 'from-rose-500 to-pink-500',
    features: [
      'User Research & Testing',
      'Wireframing & Prototyping',
      'Visual Design',
      'Interaction Design',
      'Design System Creation',
      'Accessibility Compliance'
    ],
    benefits: [
      'Higher User Engagement',
      'Improved Conversion Rates',
      'Better Brand Perception',
      'Reduced Development Costs'
    ],
    process: [
      'User Research',
      'Information Architecture',
      'Design & Prototyping',
      'User Testing',
      'Implementation Support'
    ],
    image: 'https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?w=800&h=600&fit=crop'
  }

  const extension = {
  keyFeatures: [
    {
      name: "User Research & Persona Development",
      description: "Gain deep insight into user behavior and design products around real needs",
      icon: Users,
    },
    {
      name: "Wireframing & Prototyping",
      description: "Visualize layouts and test interactions before development begins",
      icon: LayoutTemplate,
    },
    {
      name: "UI Design Systems",
      description: "Scalable, consistent, and brand-aligned visual components",
      icon: Palette,
    },
    {
      name: "UX Strategy",
      description: "Create seamless user journeys across platforms and devices",
      icon: Route,
    },
    {
      name: "Accessibility Design",
      description: "Design inclusive products that meet WCAG and ADA standards",
      icon: Eye,
    },
    {
      name: "Interaction & Micro-Animations",
      description: "Add intuitive animations that guide users and enhance usability",
      icon: Move,
    },
  ],

  benefits: [
    {
      title: "Enhanced User Engagement",
      description: "Keep users coming back with intuitive and delightful interfaces",
      icon: Smile,
    },
    {
      title: "Improved Conversion Rates",
      description: "Reduce friction in the user journey and increase signups or sales",
      icon: TrendingUp,
    },
    {
      title: "Faster Development Cycles",
      description: "Minimize rework with design systems and validated prototypes",
      icon: Timer,
    },
    {
      title: "Accessible & Inclusive Design",
      description: "Reach more users and ensure compliance with accessibility standards",
      icon: Globe,
    },
  ],

  process: [
    {
      step: "Discovery & User Research",
      description: "Understand user goals, behaviors, and challenges through interviews and data",
      duration: "1–2 Weeks",
    },
    {
      step: "Wireframing & Ideation",
      description: "Sketch and validate layout ideas and user flows",
      duration: "1–2 Weeks",
    },
    {
      step: "High-Fidelity UI Design",
      description: "Craft pixel-perfect, brand-consistent interface designs",
      duration: "2–3 Weeks",
    },
    {
      step: "Prototyping & Testing",
      description: "Test design functionality and gather real feedback before development",
      duration: "1–2 Weeks",
    },
    {
      step: "Handoff to Development",
      description: "Deliver design specs and assets with support for smooth implementation",
      duration: "Ongoing collaboration",
    },
  ],

  techStack: [
    { name: "Figma", icon: PenTool, category: "Design & Prototyping" },
    { name: "Adobe XD", icon: PenTool, category: "Design & Prototyping" },
    { name: "Sketch", icon: PenTool, category: "Design Tool" },
    { name: "Zeplin", icon: Layers, category: "Design Handoff" },
    { name: "Framer", icon: MonitorSmartphone, category: "Prototyping Tool" },
    { name: "React + Tailwind CSS", icon: Code, category: "Frontend Implementation" },
  ],
};

  return (
    <Fragment>
        <MetaTagComponent metaDetails={metaUIdevelopment}/>
        <ServiceDetailSection service={service} extension={extension} />
    </Fragment>
  )
}

export default UIDevelopment